export const superAdminT = {
  es: {
    users: "usuarios",
    trainers: "entrenadores",
    withLab: "con LAB",
    blocked: "bloqueados",
    logout: "Cerrar sesión",
    allRoles: "Todos los roles",
    refresh: "Actualizar",
    results: "resultados",
    searchPlaceholder: "Buscar por nombre, email, username...",
    colUser: "USUARIO",
    colEmail: "EMAIL",
    colRole: "ROL",
    colStatus: "ESTADO",
    colLab: "LAB",
    colRegistered: "REGISTRO",
    colActions: "ACCIONES",
    block: "⊘ Bloquear",
    unblock: "✓ Activar",
    delete: "🗑 Eliminar",
    protected: "Protegido",
    noUsers: "No hay usuarios",
    confirmDeleteTitle: "⚠️ Confirmar eliminación",
    confirmDeleteBtn: "Sí, eliminar",
    cancel: "Cancelar",
    labActivated: "Acceso LAB activado",
    labRevoked: "Acceso LAB revocado",
    labError: "Error actualizando acceso LAB",
    actionError: "Error ejecutando acción",
    loadError: "Error cargando usuarios",
  },
  en: {
    users: "users",
    trainers: "trainers",
    withLab: "with LAB",
    blocked: "blocked",
    logout: "Log out",
    allRoles: "All roles",
    refresh: "Refresh",
    results: "results",
    searchPlaceholder: "Search by name, email, username...",
    colUser: "USER",
    colEmail: "EMAIL",
    colRole: "ROLE",
    colStatus: "STATUS",
    colLab: "LAB",
    colRegistered: "REGISTERED",
    colActions: "ACTIONS",
    block: "⊘ Block",
    unblock: "✓ Activate",
    delete: "🗑 Delete",
    protected: "Protected",
    noUsers: "No users found",
    confirmDeleteTitle: "⚠️ Confirm deletion",
    confirmDeleteBtn: "Yes, delete",
    cancel: "Cancel",
    labActivated: "LAB access activated",
    labRevoked: "LAB access revoked",
    labError: "Error updating LAB access",
    actionError: "Error executing action",
    loadError: "Error loading users",
  }
};
